import { requestApi } from "../axios";

export function registerApplication(data) {
  return requestApi(`/admin/partner-app/register`, "POST", data);
}

export function listingApplication(limit, offset, all) {
  return requestApi(`/admin/partner-app?limit=${limit}&offset=${offset}${all ? "&type=ALL" : ""}`, "GET");
}

export function deleteApplication(id) {
  return requestApi(`/admin/partner-app/${id}`, "DELETE");
}

export function updateFacebookToken(data) {
  return requestApi(`/admin/partner-app/facebook-token`, "PUT", data);
}

export function connectStore(data) {
  return requestApi(`/admin/partner-app/connect`, "POST", data);
}

// Event & metric
export function getEvents(appId, partnerCode) {
  return requestApi(`admin/kpi/get-events?app_id=${appId}&partner_code=${partnerCode}`, "GET");
}

// event data key name
export function getListKeyName(appId, eventKey, fromDate, toDate, platform) {
  return requestApi(`admin/kpi/list-key-name`, "GET", {
    app_id: appId,
    event_key: eventKey,
    from_date: fromDate,
    to_date: toDate,
    platform: platform,
  });
}

export function getListKeyValueTopAPI(fromDate, toDate, appId, eventKey, eventDataKeyName, platform) {
  return requestApi(`admin/kpi/list-key-value-top`, "GET", {
    from_date: fromDate,
    to_date: toDate,
    app_id: appId,
    event_key: eventKey,
    event_key_name: eventDataKeyName,
    platform,
  });
}

export function createCustomDomain(data) {
  return requestApi(`/admin/partner-app/custom-domain`, "POST", data);
}

export function getCustomDomain(appId) {
  return requestApi(`/admin/partner-app/custom-domain?appId=${appId}`, "GET");
}

// Lịch sử chỉnh sửa cấu hình của 1 app. params: { feature?, limit, offset }
export function getAppChangeHistory(appId, { feature, limit = 20, offset = 0 } = {}) {
  const query = new URLSearchParams({ appId, limit, offset, ...(feature ? { feature } : {}) });
  return requestApi(`/admin/partner-app/change-history?${query.toString()}`, "GET");
}
